__webpack_require__.p = "https://behaviorlivecdn.blob.core.windows.net/behaviorlive-prod/8.0.0.600/dist/";